import React from 'react';
import { Link } from 'react-router-dom'
import './ContactUs.css';
import logComponent from '../../common/logComponent';

export default function ContactUs() {

  if (logComponent('ContactUs')) { console.debug('ContactUs rendered'); }

  return (
    <Link to='../contactus'
      target='_blank'>
      Contact Us
    </Link>
  )
}
